import { Page } from '@/typings/page';
import useCurrentPage from '@/hooks/useCurrentPage';

import { CreditLeasing } from './types';

export function useCreditLeasingData(): Page<CreditLeasing> {
  return useCurrentPage<Page<CreditLeasing>>();
}
